import React, { Component } from 'react'
import { Box, CustomizedErrorMessage, ButtonLink } from '../../styles.style'
import { MuvicardService } from '../../../../services/muvicard.service'
import { getIn } from 'formik'
class Mother extends Component {
	constructor(props) {
		super(props)

		this.state = {
			motherName: '',
			terms: false,
			newsLetter: true,
			motherNameError: ''
		}
	}

	setMotherName = e => {
		const { userData, updateUserData } = this.props
		let newUserData = { ...userData }
		newUserData.motherName = e.target.value
		updateUserData(newUserData)
		let motherNameError = this.validateMotherName(newUserData.motherName)
		this.setState({ motherName: e.target.value, motherNameError })
	}

	validateMotherName = name => {
		const defaultErrorMessage = 'Informe o nome completo da sua mãe.'
		if (!name) {
			return defaultErrorMessage
		}
		const separatedNames = name.trim().split(' ')
		if (separatedNames.length < 2) {
			return defaultErrorMessage
		}
		for (let i = 0; i < separatedNames.length; ++i) {
			if (separatedNames[i].length === 1) {
				return 'Informe um nome válido.'
			}
			if (separatedNames[i] === '') {
				return 'Informe um nome sem espaços duplos.'
			}
		}
		return ''
	}

	componentDidMount() {
		const { setFieldValue, userData } = this.props

		if (userData) {
			const { motherName, newsLetter } = userData
			if (newsLetter) {
				setFieldValue('newsLetter', newsLetter)
				this.setState({ newsLetter })
			}
			if (motherName) {
				setFieldValue('motherName', motherName)
				this.setState({ motherName })
			}
		}
		MuvicardService.proposalStepRegister('Nome da mãe', 'Acesso')
	}

	onClickDownloadContract = async () => {
		await MuvicardService.DownloadMuvicardContract()
	}

	render() {
		const {
			handleBlur,
			handleChange,
			prevStep,
			values,
			errors,
			touched,
			setFieldValue
		} = this.props
		const { motherNameError } = this.state
		return (
			<Box className="box-cep">
				<div className="field">
					<header>
						<h5>Favor informar o nome da sua mãe</h5>
					</header>

					<div>
						<input
							autoComplete="off"
							type="text"
							placeholder="Nome da mãe"
							id="motherName"
							name="motherName"
							value={this.state.motherName || values.motherName}
							onChange={e => {
								this.setMotherName(e)
								handleChange(e)
								setFieldValue('motherName', e.target.value)
							}}
							onBlur={handleBlur}
							className={
								getIn(errors, 'motherName') &&
									getIn(touched, 'motherName')
									? 'field-error input-big'
									: 'input-big'
							}
						/>
					</div>
					{motherNameError && (
						<CustomizedErrorMessage>
							{motherNameError}
						</CustomizedErrorMessage>
					)}
					<div className="terms">
						<input
							className="input-check"
							id="terms"
							name="terms"
							type="checkbox"
							value={this.state.terms}
							onChange={handleChange}
						/>
						<label htmlFor="terms">
							Li e aceito o{' '}
							<ButtonLink
								type="button"
								onClick={this.onClickDownloadContract}>
								Contrato de Serviços Muvicard
							</ButtonLink>
						</label>
					</div>

					<div className="terms">
						<input
							className="input-check"
							id="newsLetter"
							name="newsLetter"
							type="checkbox"
							value={this.state.newsLetter || values.newsLetter}
							onChange={handleChange}
							checked={values.newsLetter}
						/>

						<label htmlFor="newsLetter">
							Desejo receber as <span>novidades </span>e{' '}
							<span>informações</span> da Muviflex e Muvicard por e-mail
							e SMS
						</label>
					</div>
				</div>

				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => prevStep()}>
						Voltar
					</button>
					<button
						disabled={
							this.state.motherNameError ||
							!values.terms ||
							!values.motherName
						}
						className={
							errors.motherName && touched.motherName
								? 'disabled button'
								: 'button'
						}
						type="submit">
						Solicitar meu cartão
					</button>
				</footer>
			</Box>
		)
	}
}

export default Mother
